export default () => ({
  favorites: {},
  favorited: false,
  isLoadingFavorite: false,
})
